export const DeviceOrderItemColumns = () => {
  //   function shortenListWithDots(input) {
  //     const parts = input.split(",").map((s) => s.trim());
  //     if (parts.length <= 2) return input; // No need to shorten if 2 or fewer items
  //     return `${parts.slice(0, 2).join(", ")}, ...`;
  //   }
  return [
    {
      title: "Order Time",
      dataIndex: "OrderTime",
      key: "OrderTime",
      render: (text) => (
        <div>
          {typeof text === "string" && text.length >= 16
            ? text.slice(0, 16)
            : ""}
        </div>
      ),
      onHeaderCell: () => ({ onClick: () => {} }),
      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionNo"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionNo",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Order Type",
      dataIndex: "OrderType",
      key: "OrderType",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "License Item",
      dataIndex: "LicenseItem",
      key: "LicenseItem",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionDesc"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionDesc",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },

    {
      title: "License Type",
      dataIndex: "LicenseType",
      key: "LicenseType",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    // {
    //   title: "License Time",
    //   dataIndex: "LicenseTime",
    //   key: "LicenseTime",
    //   onHeaderCell: () => ({ onClick: () => {} }),
    // },
    {
      title: "Old License",
      dataIndex: "OldCode",
      key: "OldCode",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "New License",
      dataIndex: "NewCode",
      key: "NewCode",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionTime"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionTime",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Free",
      dataIndex: "Free",
      key: "Free",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
    },
  ];
};
